import "./../styles/notice.css";
import { getNotices } from "../api/notice";
import React, { useEffect, useState } from "react";
const Notice = () => {
  const [notices, setNotices] = useState([
    {
      projectName: "默认测试数据",
      projectNo: "默认测试数据",
      projectStatus: "测试中",
      createTime: "2023-05-01",
    },
  ]);
  const [searchParams, setSearchParams] = useState({
    projectStatus: "",
    projectName: "",
    projectNo: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // 假设的关键字选项列表
  const projectStatusOptions = [
    { value: "", label: "全部" },
    { value: "正在采购", label: "正在采购" },
    { value: "采购截止", label: "采购截止" },
  ];
  useEffect(() => {
    fetchNotices(currentPage, searchParams);
  }, [currentPage, searchParams]);
  const fetchNotices = (page, params) => {
    getNotices({
      domain: {
        ...params,
      },
      pageNum: page,
      pageSize: 10,
    }).then((res) => {
      setNotices(res.data.records);
      setTotalPages(Math.ceil(res.data.total / 10));
    });
  };

  const handleSearch = () => {
    setCurrentPage(1); // Reset to first page on search
    fetchNotices(1, searchParams);
  };

  const handleReset = () => {
    setSearchParams({ projectStatus: "", projectName: "", projectNo: "" });
    setCurrentPage(1);
    fetchNotices(1, { projectStatus: "", projectName: "", projectNo: "" });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // 计算需要显示的页码范围
  const pageRange = 10;
  const startPage = Math.max(1, currentPage - Math.floor(pageRange / 2));
  const endPage = Math.min(totalPages, startPage + pageRange - 1);

  return (
    <div className="notice">
      <img src="/assets/notice.png" alt="采购公告" />
      <div className="noticeList">
        <div className="notice-left">
          <div className="noticeItemTitle">采购公告</div>
        </div>
        <div className="notice-right">
          <div className="search">
            <div className="search-content">
              <select
                value={searchParams.projectStatus}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    projectStatus: e.target.value,
                  })
                }
              >
                {projectStatusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <input
                type="text"
                placeholder="请输入项目名称"
                value={searchParams.projectName}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    projectName: e.target.value,
                  })
                }
              />
              <input
                type="text"
                placeholder="请输入项目编号"
                value={searchParams.projectNo}
                onChange={(e) =>
                  setSearchParams({
                    ...searchParams,
                    projectNo: e.target.value,
                  })
                }
              />
            </div>
            <div className="search-btns">
              <button
                className="search-btn"
                type="submit"
                onClick={handleSearch}
              >
                搜索
              </button>
              <button className="reset-btn" type="reset" onClick={handleReset}>
                重置
              </button>
            </div>
          </div>
          <table className="tableList">
            <thead>
              <tr>
                <th>项目名称</th>
                <th>项目编号</th>
                <th>项目状态</th>
                <th>创建时间</th>
              </tr>
            </thead>
            <tbody>
              {notices.length === 0 ? (
                <tr>
                  <td colSpan="4">暂无数据</td>
                </tr>
              ) : (
                notices.map((notice, index) => (
                  <tr key={index}>
                    <td title={notice.projectName}>{notice.projectName}</td>
                    <td title={notice.projectNo}>{notice.projectNo}</td>
                    <td>{notice.projectStatus}</td>
                    <td>{notice.createTime}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <div className="pagination">
            <span>共 {notices.length} 条记录</span>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              上一页
            </button>
            {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
              <button
                className="page"
                key={startPage + index}
                onClick={() => handlePageChange(startPage + index)}
                disabled={currentPage === startPage + index}
              >
                {startPage + index}
              </button>
            ))}
            <button className="total-page">共 {totalPages} 页</button>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              下一页
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notice;
